export default __webpack_public_path__ + "static/media/design-ena.82703b57.png";